let isLoaded = false;
let loadPromise: Promise<void> | null = null;

// Function to load the PubSuite script
export const loadPubSuite = (): Promise<void> => {

    if (isLoaded) {
        return Promise.resolve();
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise((resolve) => {
        if (window.pubSuite) {
            isLoaded = true;
            return resolve();
        }

        const script = document.createElement("script");
        script.src = "https://storage.googleapis.com/kochava-web-assets/ps/v1.3.1/pubsuite.js";
        script.async = true;

        script.onload = () => {
            try {
                window.pubSuite?.startWithProductId(
                    "1727626",
                    "70981bb9-5190-4f88-88c9-bf7eb0aff3e7"
                );
                isLoaded = true;
            } catch (e) {
                console.error("PubSuite init failed", e);
            }
            resolve();
        };

        script.onerror = (e) => {
            console.warn("PubSuite blocked or failed", e);
            loadPromise = null; // allow retry
            resolve(); // don't reject
        };

        document.head.appendChild(script);
    });

    return loadPromise;
};

// Function to send a conversion
export const sendConversion = async (conversionName: string) => {

    await loadPubSuite(); 

    if (window.pubSuite) {
        window.pubSuite.sendConversion(conversionName);
    } else {
        console.warn("PubSuite not loaded yet");
    }
};